import { createRouter, createWebHistory } from "vue-router";
import Home from "../views/Home";

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/about",
    name: "About",
    component: () => import("../views/about/index"),
    redirect: "/about/js",
    children: [
      {
        path: "js",
        component: () => import("../views/about/js")
      },
      {
        path: "zz",
        component: () => import("../views/about/zz")
      },
      {
        path: "lc",
        component: () => import("../views/about/lc")
      },
      {
        path: "hb",
        component: () => import("../views/about/hb")
      }
    ]
  },
  {
    path: "/product",
    name: "Product",
    component: () => import("../views/product/index"),
    redirect: "/product/list",
    children: [
      {
        path: "list",
        name: "productList",
        component: () => import("../views/product/list"),
      },
      {
        path: ":id",
        name: "productInfo",
        component: () => import("../views/product/info"),
      }
    ]
  },
  {
    path: "/solution",
    name: "Solution",
    component: () => import("../views/solution/index")
  },
  {
    path: "/case",
    name: "Case",
    component: () => import("../views/case/index"),
    redirect: "/case/list",
    children: [
      {
        path: "list",
        name: "caseList",
        component: () => import("../views/case/list"),
      },
      {
        path: "info",
        name: "caseInfo",
        component: () => import("../views/case/info"),
      }
    ]
  },
  {
    path: "/news",
    name: "News",
    component: () => import("../views/news/index"),
    redirect: "/news/list",
    children: [
      {
        path: "list",
        name: "newsList",
        component: () => import("../views/news/list"),
      },
      {
        path: "info",
        name: "newsInfo",
        component: () => import("../views/news/info"),
      }
    ]
  },
  {
    path: "/countact",
    name: "Contact",
    component: () => import("../views/countact/index"),
    redirect: "/countact/ln",
    children: [
      {
        path: "ln",
        name: "Ln",
        component: () => import("../views/countact/ln")
      },
      {
        path: "zp",
        name: "Zp",
        component: () => import("../views/countact/zp")
      },
      {
        path: "lx",
        name: "Lx",
        component: () => import("../views/countact/lx")
      },
    ]
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  // history: createWebHistory("/en/"), // 结尾一定要带/
  routes,
});

export default router;
